import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { MyHomeState } from '../../state/my-home.state';

@Component({
  selector: 'app-home-property-details',
  templateUrl: './home-property-details.component.html',
  styleUrls: ['./home-property-details.component.scss'],
})
export class HomePropertyDetailsComponent implements OnInit, OnChanges {
  constructor(private myHomeState: MyHomeState) {}
  @Input() selectedIndexTab;
  selected = 0;
  resetFeatures = false;

  ngOnInit() {
    let previousPmxId: string | null = null;
    this.myHomeState.activeHome$.subscribe((res: any) => {
      if (res) {
        const currentPmxId = res?.id;
        if (previousPmxId !== currentPmxId) {
          previousPmxId = currentPmxId;
          this.selected = 0;
        }
      }
    });
  }

  ngOnChanges(): void {
    if (this.selectedIndexTab == 0) {
      this.selected = 0;
      this.resetFeatures = true;
    } else {
      this.resetFeatures = false;
    }
  }
}
